import script from "./ContentCollapsibleList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentCollapsibleList.vue?vue&type=script&setup=true&lang=js"

import "./ContentCollapsibleList.vue?vue&type=style&index=0&id=7828d646&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7828d646"]])

export default __exports__